import { ICertificationStatusReportRowItem } from '../CertificationStatusReportTable/CertificationStatusReportTable';
import { DateTime } from 'luxon';
import { CertificationRecord } from '../types/types';
import { isStringInUnionList } from 'utils/stringUtils';
import {
  supportedCertificationAttachmentFileType,
  TSupportedCertificationAttachmentFileType,
} from '../constants/constants';

export const mapCertificationRecordToTableData = (
  records: CertificationRecord[]
): ICertificationStatusReportRowItem[] => {
  return records.map((record) => ({
    id: record.id,
    member: record.member,
    certification: record.certification,
    issueDate: DateTime.fromISO(record.renewedOn).toFormat('LLL dd, yyyy'),
    expirationDate: record.expiresOn ? DateTime.fromISO(record.expiresOn).toFormat('LLL dd, yyyy') : '',
    renewal: DateTime.fromISO(record.updatedOn).toFormat('LLL dd, yyyy'),
    certificationRecord: record,
  }));
};

export const getExpirationDate = (issueDate: Date, months: number): DateTime => {
  const expirationDate = DateTime.fromJSDate(issueDate);
  return expirationDate.plus({ months });
};

export function isSupportedCertificationAttachmentFileType(
  value: string
): value is TSupportedCertificationAttachmentFileType {
  return isStringInUnionList<TSupportedCertificationAttachmentFileType>(
    value,
    supportedCertificationAttachmentFileType
  );
}
